import React, { useState } from 'react';
import { Card, Form, Row, Col, Select, Button, Spin, message } from 'antd';
import { getNonPriorityCustomerAccountsReport } from './SavingService';
import { exportNonPriorityCustomerAccountsExcel } from '../../Utils/NonPriorityCustomerAccountsExcelExport';

const { Option } = Select;

const EXCLUDED_PRODUCT_CODES = ['101', '103'];

const NonPriorityCustomerAccountsReport = ({ products = [], loginPlaceId }) => {
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [loading, setLoading]                     = useState(false);

    const selectableProducts = products.filter((product) => {
        const code = String(product.productCode ?? product.prdCode ?? '').trim();
        return !EXCLUDED_PRODUCT_CODES.includes(code);
    });

    const handleProductChange = (val) => {
        setSelectedProductId(val);
    };

    const getSelectedProductName = () => {
        const prod = selectableProducts.find(
            (p) => (p.productId || p.prdId) === selectedProductId
        );
        return prod ? (prod.productName || prod.prdName) : '';
    };

    const handleGenerateReport = async () => {
        if (!selectedProductId) {
            message.warning('Please select a Savings Product.');
            return;
        }

        setLoading(true);

        try {
            const payload = {
                productId: selectedProductId,
            };
            const response = await getNonPriorityCustomerAccountsReport(payload);
            const data = Array.isArray(response) ? response : [];

            if (data.length === 0) {
                message.warning('No accounts found for the selected savings product.');
                return;
            }

            await exportNonPriorityCustomerAccountsExcel({
                data,
                productName: getSelectedProductName(),
                loginPlaceId,
            });

            message.success(`Report generated and downloaded successfully (${data.length} account(s)).`);
        } catch (err) {
            console.error('NonPriorityCustomerAccountsReport fetch error:', err);
            message.error('Failed to generate report: ' + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Savings Product" required>
                                <Select
                                    id="non-priority-customer-accounts-product-select"
                                    showSearch
                                    allowClear
                                    placeholder="Select product"
                                    style={{ width: '100%' }}
                                    value={selectedProductId}
                                    onChange={handleProductChange}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    size="large"
                                >
                                    {selectableProducts.map((product) => {
                                        const id = product.productId ?? product.prdId;
                                        const code = product.productCode ?? product.prdCode ?? '';
                                        const name = product.productName ?? product.prdName ?? '';
                                        return (
                                            <Option key={id} value={id}>
                                                {code ? `${code} - ${name}` : name}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    id="non-priority-customer-accounts-generate-btn"
                                    onClick={handleGenerateReport}
                                    disabled={loading || !selectedProductId}
                                    className="generate-btn"
                                    style={{ textAlign: 'right' }}
                                    size="large"
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default NonPriorityCustomerAccountsReport;
